Modal = require 'components/common/modal'
utils = require 'base/lib/utils'
Tooltip = require 'components/common/tooltip'
EmbeddedHTMLEditor = require 'components/common/gdt_editor/embedded_html_editor'
Confirmation = require 'components/common/confirmation'
QualityIndicatorsTable = require 'components/common/gdt_editor/quality_indicators_table'
NmaTablePrintout = require 'components/nma/nma_table_printout'
ThresholdPlot = require 'components/evidence_syntheses/threshold_plot'
{
  CollapsedInsertedGdtTable,
  CollapseTableButton,
  DxEvidenceTable,
  EditorUtils,
  RelativeImportance,
  LayerOneTwoSof,
  OpenInNewWindowButton,
  SofShort,
  SofTable,
} = Editor

Translation = require 'components/mixins/translation'
{ getTableData } = require 'lib/embedded_content'

gdtTableStyles =
  controls:
    position: 'fixed'
    height: '25px'
    border: '1px solid lightgrey'
    backgroundColor: '#dedede'
    top: '0'
  button:
    padding: '0 5px'

EditableTable = createReactClass
  applyEdit: (content) ->
    @props.onApply content

  render: ->
    { data, isEditing } = @props
    <div>
      {if isEditing
        <EmbeddedHTMLEditor html={data} onClose={@props.onClose} onApply={@applyEdit} />
      }
      <div
        className='embedded'
        dangerouslySetInnerHTML={__html: data}
       />
    </div>

EpiditorGdtTable = createReactClass
  displayName: 'EpiditorGdtTable'

  mixins: [
    Translation('')
  ]

  getInitialState: ->
    showControls: false
    showConfirmationFor: null
    manuallyEditing: false

  _getTableProps: ->
    @props.attrs

  _getTableHtml: ->
    tableContent = ReactDOM.findDOMNode @tableContent
    return '' unless tableContent?

    clone = tableContent.cloneNode true
    $(clone)
      .find('button, .inserted-table_buttons-row')
      .remove()

    clone.innerHTML.replace(/\sdata-reactid="[^"]+"/g, '')

  _resetTableData: ->
    { type, selectedOutcomes, qId, expanded } = @_getTableProps()
    tableData = getTableData type, Immutable.fromJS(selectedOutcomes), qId
    @props.updateAttrs data: tableData, expanded: expanded

  showConfirmationFor: (confirmationAction) -> =>
    @setState showConfirmationFor: confirmationAction

  hideConfirmation: ->
    @setState showConfirmationFor: null

  cancelConfirmation: ->
    @hideConfirmation()
    @props.focusEditor()

  onConfirm: (confirmedAction) -> =>
    switch confirmedAction
      when 'update' then @resetTableData()
      when 'edit' then @editTable()

  resetTableData: ->
    @hideConfirmation()
    @_resetTableData()

  editTable: ->
    { manualEdit, data } = @_getTableProps()

    html = @_getTableHtml()
    data = _.extend {}, data, { html: html }

    if manualEdit
      @setState
        manuallyEditing: true
        showConfirmationFor: null
    else
      @props.updateAttrs
        manualEdit: true
        data: data
      @setState
        manuallyEditing: true
        showConfirmationFor: null

  onEdit: ->
    { manualEdit } = @_getTableProps()
    return @setState manuallyEditing: true if manualEdit
    @showConfirmationFor('edit')()

  saveManualEdit: (newContent) ->
    { data } = @_getTableProps()
    data = _.extend {}, data, { html: newContent }
    @props.updateAttrs data: data
    @cancelManualEdit()

  cancelManualEdit: ->
    @setState manuallyEditing: false
    @props.focusEditor()

  onMouseOver: (evt) ->
    return if not @props.isEditing
    @setState showControls: true
    @currentY = evt.pageY
    @animationId = requestAnimationFrame @_moveControls

  onMouseLeave: ->
    return unless @state.showControls
    cancelAnimationFrame @animationId
    @setState showControls: false
    @currentY = null

  onMouseMove: (evt) ->
    return unless @state.showControls
    @currentY = evt.pageY

  _moveControls: ->
    return if not @controls or @state.manuallyEditing
    width = @controls.clientWidth
    @controls.style.transform =
      "translateY(#{@currentY - 10}px) translateZ(0) translateX(-#{width}px)"
    @animationId = requestAnimationFrame @_moveControls

  toggleTable: (e) ->
    e?.preventDefault?()
    e?.stopPropagation?()
    { type, selectedOutcomes, qId, data, expanded } = @_getTableProps()
    if typeof data is 'string'
      tmpData = getTableData type, Immutable.fromJS(selectedOutcomes), qId
      data = _.extend {}, tmpData, { html: data }

    @props.updateAttrs { data: data, expanded: not expanded }, true

  openTableInNewWindow: (e) ->
    e?.preventDefault?()
    e?.stopPropagation?()
    { data } = @_getTableProps()
    EditorUtils.openTableInNewWindow data.title, @_getTableHtml()

  renderTable: ->
    { type, data, manualEdit } = @_getTableProps()
    effectiveRenderMode = if @props.renderMode is 'printout' or @props.exportMode
      'printout'
    else
      @props.renderMode

    if manualEdit
      return <EditableTable
                data={data.html}
                isEditing={@state.manuallyEditing}
                onApply={@saveManualEdit}
                onClose={@cancelManualEdit}
              />
    switch type
      when 'test_accuracy'
        <EditableTable
          data={data.html ? Handlebars.partials.testAccuracySummary(data)}
          isEditing={false}
          onApply={@saveManualEdit}
          onClose={@cancelManualEdit}
        />
      when 'l1_sof', 'l2_sof'
        <LayerOneTwoSof data={data} />
      when 'evidence_short'
        <DxEvidenceTable data={data} />
      when 'relative_importance'
        <RelativeImportance data={data} />
      when 'sof_short'
        <SofShort data={data} />
      when 'sof_v1', 'sof_v2', 'sof_v3'
        <SofTable data={data} />
      when 'quality_indicators'
        <QualityIndicatorsTable
          readOnly
          qualityIndicators={Immutable.fromJS(data.qualityIndicators)}
        />
      when 'threshold_plot'
        <ThresholdPlot
          sourceType={data.sourceType ? @_getTableProps().sourceType}
          qId={data.qId ? @_getTableProps().qId}
          plotMode={data.plotMode ? @_getTableProps().plotMode}
          comparisonKey={data.comparisonKey ? @_getTableProps().comparisonKey}
          outcomeId={data.outcomeId ? @_getTableProps().outcomeId}
          includeNetEffect={data.includeNetEffect ? @_getTableProps().includeNetEffect}
          selectedComparisonKeys={data.selectedComparisonKeys ? @_getTableProps().selectedComparisonKeys}
          selectedOutcomeIds={data.selectedOutcomeIds ? @_getTableProps().selectedOutcomeIds}
          renderMode={effectiveRenderMode}
        />
      when 'nma_printout_table'
        <NmaTablePrintout
          qId={data.qId ? @_getTableProps().qId}
          props={if data.props? then _.extend {}, data.props, i18nInstance: i18next else null}
          settings={data.settings}
          vizConfig={_.extend {}, data.vizConfig ? {},
            comparatorId: data.comparatorId ? @_getTableProps().comparatorId
            comparatorTableMode: data.comparatorTableMode ? @_getTableProps().comparatorTableMode
            denominator: data.denominator ? @_getTableProps().denominator
            interventionComparisonPairs: data.interventionComparisonPairs ? @_getTableProps().interventionComparisonPairs
            selectedInterventionIds: data.selectedInterventionIds ? @_getTableProps().selectedInterventionIds
            selectedOutcomeIds: data.selectedOutcomeIds ? @_getTableProps().selectedOutcomeIds
            showHighlights: data.showHighlights ? @_getTableProps().showHighlights
            showThresholds: data.showThresholds ? @_getTableProps().showThresholds
            tableOrder: data.tableOrder ? @_getTableProps().tableOrder
            transposed: data.transposed ? @_getTableProps().transposed
          }
        />
      else
        false

  collapsedTable: ->
    { data, type } = @_getTableProps()

    outcomesSize = data.outcomes?.length ? 0
    tableTitle = switch type
      when "threshold_plot", "nma_printout_table"
        "<b>#{utils.capitalizeFirstLetter(data.title or '')}</b>"
      else
        "#{@i18n('editor.table')}: <b>#{utils.capitalizeFirstLetter(data.title)}</b>"
    outcomesText = switch type
      when "threshold_plot", "nma_printout_table"
        ""
      else
        if outcomesSize is 1
          "#{@i18n('editor.outcome')} #{outcomesSize}"
        else
          "#{@i18n('editor.outcomes')} #{outcomesSize}"

    <CollapsedInsertedGdtTable
      tableData={data}
      tableTitle={tableTitle}
      outcomesText={outcomesText}
      onToggle={@toggleTable}
      openInNewWindow={@openTableInNewWindow}
      expandTitle={@i18n 'editor.expand_table'}
      openInNewWindowTitle={@i18n 'editor.open_table_in_new_window'}
    />

  tableRef: (e) ->
    @tableContent = e

  render: ->
    tableComponent = @renderTable()
    { renderMode, forceTableExpand } = @props
    return null unless tableComponent

    { type, initialType, manualEdit, expanded, renderMode: tableRenderMode } = @_getTableProps()

    if renderMode is 'printout' or forceTableExpand or tableRenderMode is 'printout' or @props.exportMode
      return <div data-content-type={initialType ? type}>
        {tableComponent}
      </div>

    <div
      className="relative"
      onMouseOver={@onMouseOver}
      onMouseLeave={@onMouseLeave}
      onMouseMove={@onMouseMove}
      data-content-type={initialType ? type}
    >
      {if @state.showConfirmationFor
        <Modal className='confirmation-modal' isOpen>
          <Confirmation
            question={@i18n "messages.table_#{@state.showConfirmationFor}_confirm"}
            onCancel={@cancelConfirmation}
            onConfirm={@onConfirm @state.showConfirmationFor}
          />
        </Modal>
      }
      {if @state.showControls and expanded
        <div ref={(el) => @controls = el} style={gdtTableStyles.controls}>
          {unless manualEdit or type is 'threshold_plot' or type is 'nma_printout_table'
            <Tooltip>
              <button
                className='refresh'
                style={gdtTableStyles.button}
                title={@i18n 'editor.tooltips.update_data'}
                onClick={@showConfirmationFor 'update'}
              />
            </Tooltip>
          }
          <Tooltip>
            <button
              className='edit'
              style={gdtTableStyles.button}
              title={@i18n 'editor.tooltips.edit_manually'}
              onClick={@onEdit}
            />
          </Tooltip>
        </div>
      }
      <div ref={(el) => @tableContainer = el} >
        {not expanded and @collapsedTable()}
        {expanded and
          <div className="inserted-table_buttons-row">
            <CollapseTableButton
              label={@i18n 'editor.collapse_table'}
              onClick={@toggleTable}
            />
            <OpenInNewWindowButton
              label={@i18n 'editor.open_table_in_new_window'}
              onClick={@openTableInNewWindow}
            />
          </div>
        }
        <div ref={@tableRef} className={classNames 'hidden': not expanded}>
          {tableComponent}
        </div>
      </div>
    </div>

module.exports = EpiditorGdtTable
